/* eslint-disable camelcase */
import { mapFields } from 'vuex-map-fields'
import * as hp from 'helper-js'
import { convertTreeToList } from '@/helpers/dialogTree'
import cloneDeep from 'lodash.clonedeep'
import { v4 as uuidv4 } from 'uuid'

export default {
  computed: {
    ...mapFields('dialogEdit', ['editDialog', 'nodePath', 'typeDialog'])
  },
  methods: {
    newNodeObj (folder) {
      return {
        $folded: true,
        data: {
          title: '',
          dialog_node: `customNode_${uuidv4()}`,
          type: folder ? 'folder' : 'standard',
          output: !folder ? {
            generic: [
              {
                response_type: 'text',
                values: [],
                selection_policy: 'sequential'
              }
            ]
          } : null,
          context: {},
          next_step: !folder ? {
            behavior: 'get_user_input'
          } : null,
          conditions: '',
          outputResponses: []
        },
        children: []
      }
    },
    /**
     * Adds the given node to the given path in the given tree
     * @param {Array} tree The tree of nodes
     * @param {Object} node The node to be added
     * @param {Array<number>} path The path where to put the new node
     */
    addNode (tree, node, path) {
      this.editDialog = false
      const treeHelper = new hp.TreeData(tree)
      const parent = treeHelper.getNodeParent(path)
      const nodePosition = path[path.length - 1]
      const siblingsArray = parent?.children || tree
      siblingsArray.splice(nodePosition, 0, node)
      const prevSibling = siblingsArray[nodePosition - 1]
      // eslint-disable-next-line camelcase
      node.data.parent = parent?.data?.dialog_node
      // eslint-disable-next-line camelcase
      node.data.previous_sibling = prevSibling?.data?.dialog_node
      this.nodePath = path
      this.setNodeData(node)
      this.typeDialog = 'create'
      this.$nextTick(() => {
        // console.log(`sroll to`, node)
        const id = node.data.dialog_node
        const yOffset = -10
        const element = document.getElementById(id)
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset

        window.scrollTo({ top: y, behavior: 'smooth' })
        // document.getElementById(node.data.dialog_node).scrollIntoView({
        //   behavior: 'smooth'
        // })
      })
      this.nodeMap[node.data.dialog_node] = node
      return node
    },
    async duplicateNode (tree, node, nodePath) {
      let oldNodeIdToNewNodeId = new Map()
      let newNode = cloneDeep(node)
      const newRootId = `customNode_${uuidv4()}`
      oldNodeIdToNewNodeId.set(newNode.data.dialog_node, newRootId)
      newNode.data.dialog_node = newRootId
      newNode.data.previous_sibling = node.data.dialog_node
      newNode.data.title += ' [Cópia]'

      let newNodeOutputResponses = []
      const outputResponsesLength = newNode.data.outputResponses?.length
      if (outputResponsesLength > 0) {
        newNode.data.outputResponses.forEach((response, index) => {
          const isFirstCondition = index === 0
          let newItem = {
            ...response,
            dialog_node: `customResponse_${uuidv4()}`,
            parent: newNode.data.dialog_node
          }
          newItem.title = newItem.dialog_node
          if (!isFirstCondition) {
            newItem.previous_sibling = newNodeOutputResponses[index - 1].dialog_node
          }
          newNodeOutputResponses.push(newItem)
        })
        newNode.data.outputResponses = cloneDeep(newNodeOutputResponses)
      }

      let path = [...nodePath]
      path[path.length - 1]++
      this.addNode(tree, newNode, path)

      // Go through every sub node from the onde just created
      hp.depthFirstSearch(newNode, (child, index, parent) => {
        if (!parent) return
        const newNodeId = `customNode_${uuidv4()}`
        oldNodeIdToNewNodeId.set(child.data.dialog_node, newNodeId)
        child.data.dialog_node = newNodeId
        child.data.parent = parent.data.dialog_node
        const prevSibling = parent.children[index - 1]
        child.data.previous_sibling = prevSibling?.data?.dialog_node
        if (child.data.outputResponses.length !== 0) {
          child.data.outputResponses.reduce((curr, next) => {
            curr.parent = child.data.dialog_node
            const newResponseId = `customNode_${uuidv4()}`
            oldNodeIdToNewNodeId.set(curr.dialog_node, newResponseId)
            curr.dialog_node = newResponseId
            if (next) next.previous_sibling = curr.dialog_node
            return next
          })
        }
      })
      let cloneNewNode = cloneDeep(newNode)
      if (newNode.children.length > 0 && outputResponsesLength > 0) {
        const previousSibling = newNodeOutputResponses.pop().dialog_node
        let childrenList = cloneNewNode.children.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              data: {
                ...item.data,
                previous_sibling: previousSibling
              }
            }
          } else {
            return { ...item }
          }
        })
        newNode.children = childrenList
      }

      this.deepWalk(newNode, (node) => {
        const nodeData = this.getNodeData(node)
        const nextStepNode = nodeData?.next_step?.dialog_node || null
        const newNextStepNode = oldNodeIdToNewNodeId.get(nextStepNode)
        if (nextStepNode && newNextStepNode) {
          nodeData.next_step.dialog_node = newNextStepNode
        } else if (!nextStepNode && newNextStepNode) {
          throw new Error('Consistency error')
        }
        this.nodeMap[nodeData.dialog_node] = node
      })

      const { nextSibling } = this.getNodeSiblings(tree, path)
      if (nextSibling) {
        nextSibling.data.previous_sibling = newNode.data.dialog_node
      }
      let findIndexNewNode = tree.findIndex(item => item.data.dialog_node === newRootId)
      tree[findIndexNewNode] = newNode
      await this.saveDialogNodes(
        tree,
        'duplicateNode'
      )
    },
    /**
     *
     * @param {Object} tree
     * @param {Array[number]} nodePath
     * @returns {{prevSibling: Object, nextSibling: Object}}
     */
    getNodeSiblings (tree, nodePath) {
      const treeHelper = new hp.TreeData(tree)
      const parent = treeHelper.getNodeParent(nodePath)
      const siblingsArray = parent?.children || tree
      const prevSiblingPosition = nodePath[nodePath.length - 1] - 1
      const nextSiblingPosition = nodePath[nodePath.length - 1] + 1
      return {
        prevSibling: siblingsArray[prevSiblingPosition],
        nextSibling: siblingsArray[nextSiblingPosition]
      }
    },
    async addSiblingBellow (tree, siblingPath) {
      const path = [...siblingPath]
      path[path.length - 1]++
      const newNode = this.addNode(tree, this.newNodeObj(false), path)
      const treeHelper = new hp.TreeData(tree)
      const parent = treeHelper.getNodeParent(siblingPath)
      const siblingsArray = parent?.children || tree
      const nextSiblingPosition = path[path.length - 1] + 1
      const nextSibling = siblingsArray[nextSiblingPosition]
      if (nextSibling) {
        nextSibling.data.previous_sibling = newNode.data.dialog_node
      }
      await this.saveDialogNodes(
        tree,
        'createNode'
      )
      // console.log('response', response)
    },
    async addSiblingAbove (tree, sibling, siblingPath) {
      this.addNode(tree, this.newNodeObj(false), [...siblingPath])
      await this.saveDialogNodes(
        tree,
        'createNode'
      )
    },
    async appendNewChild (tree, parentNode, parentPath) {
      const path = [...parentPath, parentNode.children.length]
      parentNode.$folded = false
      this.addNode(tree, this.newNodeObj(false), path)
      await this.saveDialogNodes(
        tree,
        'createNode'
      )
    },
    async appendNewRootNode (tree) {
      this.addNode(tree, this.newNodeObj(false), [tree.length])
      await this.saveDialogNodes(
        tree,
        'createNode'
      )
    },
    async appendNewFolder (tree) {
      this.addNode(tree, this.newNodeObj(true), [tree.length])
      await this.saveDialogNodes(
        tree,
        'createNode'
      )
    },
    async deleteNode (tree, node, path) {
      try {
        this.editDialog = false

        // Find all nodes and responses being deleted and save them on "before"
        const nodesBeingDeleted = new Map()
        this.deepWalk(node, nodeOrResponse => {
          const nodeData = this.getNodeData(nodeOrResponse)
          delete this.nodeMap[node.data.dialog_node]
          nodesBeingDeleted.set(nodeData.dialog_node, true)
        })

        /**
         * In the new tree, if a node has a next_step pointing to a deleted node:
         * Save it's state on "before", delete de next_step prop and save its new
         * state in "after".
         */
        this.deepWalk(tree, nodeOrResponse => {
          const nodeData = this.getNodeData(nodeOrResponse)
          const nextStep = nodeData?.next_step?.dialog_node
          if (nodesBeingDeleted.has(nextStep)) {
            delete nodeData.next_step
          }
        })

        // let nextNode
        // try {
        //   nextNode = treeHelper.getNode(path)
        // } catch (e) {
        //   nextNode = null
        // }

        // Update the previous_sibling property of the node placed after the one deleted
        // The next node of the one deleted now occupies its place
        // if (nextNode) {
        //   if (!beforeMap.has(nextNode.data.dialog_node)) {
        //     beforeMap.set(
        //       nextNode.data.dialog_node,
        //       convertTreeNodeToDialogNode(nextNode.data)
        //     )
        //   }
        //   const { prevSibling } = this.getNodeSiblings(tree, path)
        //   const parent = treeHelper.getNodeParent(path)
        //   setPreviousSibling(nextNode, prevSibling, parent)
        //   afterMap.set(
        //     nextNode.data.dialog_node,
        //     convertTreeNodeToDialogNode(nextNode.data)
        //   )
        // }

        // Effectively remove node from tree
        const treeHelper = new hp.TreeData(tree)
        treeHelper.removeNode(path)
        delete this.nodeMap[node.data.dialog_node]

        return await this.saveDialogNodes(
          tree,
          'deleteNodes',
          node
        )
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async saveDialogNodes (tree, type, node = undefined) {
      try {
        const checkedOutSnap = this.$store.getters['snapshots/checkedOutByUser']
        let list = convertTreeToList(tree)
        let updatedList
        if (type === 'deleteNodes') {
          updatedList = this.buildListByDeletedDialog(list, node)
        } else {
          updatedList = list
        }
        await this.$store.dispatch('snapshots/save', {
          id: checkedOutSnap._id,
          data: {
            dialog_nodes: updatedList
          }
        })
        if (type === 'deleteNodes') {
          return updatedList
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },
    getNodeData (node) {
      if (node.type === 'response_condition') {
        return node
      } else {
        return node.data
      }
    },
    buildListByDeletedDialog (list, deletedItem) {
      let newList
      let newPreviousSibling = deletedItem.data.previous_sibling
      newList = this.cascadeDelete(list, deletedItem)
      let sibling = list.find(item => item.previous_sibling === deletedItem.data.dialog_node)
      if (sibling) {
        let siblingIndex = newList.findIndex(item => item.previous_sibling === deletedItem.data.dialog_node)
        sibling.previous_sibling = newPreviousSibling
        newList.splice(siblingIndex, 1, sibling)
      }
      return newList
    },

    cascadeDelete (list, deletedItem) {
      let listDeleted = [
        deletedItem
      ]
      let index = 0
      while (index < listDeleted.length) {
        let item = listDeleted[index]
        if (item.children.length > 0) {
          item.children.forEach(child => {
            listDeleted.push(child)
          })
        }
        index++
      }
      let listDialogNodeDeleted = listDeleted.map(item => {
        return item.data.dialog_node
      })
      return list.filter(item => !listDialogNodeDeleted.includes(item.dialog_node))
    },

    /**
     * Walks though nodes' children AND outputResponses.
     * If `responseHandler` is defined, it is used for the responses,
     * otherwise `nodeHandler` is used.
     * @param {Object | Array} root
     * @param {import('he-tree-vue').walkTreeDataCallback} nodeHandler
     * @param {import('he-tree-vue').walkTreeDataCallback} [responseHandler]
     */
    deepWalk (root, nodeHandler, responseHandler) {
      hp.depthFirstSearch(root, (node, index, parent, path) => {
        if (node.data?.metadata?._customization?.mcr === true) {
          node.data.outputResponses.forEach((response, index) => {
            if (responseHandler) {
              responseHandler(response, index, node)
            } else {
              nodeHandler(response, index, node)
            }
          })
        }
        return nodeHandler(node, index, parent, path)
      })
    }
  }
}
